var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDeleteOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.56 8.1c.5.03.87.46.84.96l-.5 8a.9.9 0 1 1-1.8-.12l.5-8a.9.9 0 0 1 .96-.84ZM9.44 8.1a.9.9 0 0 0-.84.96l.5 8a.9.9 0 0 0 1.8-.12l-.5-8a.9.9 0 0 0-.96-.84Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 4.1a.9.9 0 1 0 0 1.8h1.18l1.16 12.32c.04.48.08.9.14 1.23.06.36.16.7.35 1.03.3.5.73.9 1.25 1.14.34.16.7.22 1.06.25.34.03.75.03 1.24.03h5.24c.49 0 .9 0 1.24-.03.37-.03.72-.09 1.06-.25a2.9 2.9 0 0 0 1.25-1.14c.2-.32.29-.67.35-1.03.06-.34.1-.75.14-1.23L19.82 5.9H21a.9.9 0 1 0 0-1.8h-5.2a3.9 3.9 0 0 0-7.6 0H3Zm4.12 13.91c.05.53.09.87.13 1.14.05.25.09.35.13.41.1.19.27.34.47.43.06.03.17.07.43.09.26.02.6.02 1.13.02h5.18c.52 0 .87 0 1.13-.02.26-.02.37-.06.43-.09.2-.09.36-.24.47-.43.04-.06.08-.16.13-.41.04-.27.08-.6.13-1.14L18 5.9H6l1.13 12.11ZM12 2.9c-.84 0-1.56.49-1.9 1.2h3.8A2.1 2.1 0 0 0 12 2.9Z",
  clipRule: "evenodd"
})));
export { SvgDeleteOutline24 as ReactComponent };